import React from 'react';
import { useAppPinLock } from '@/contexts/AppPinLockContext';
import { RouteFallback } from '@/components/RouteFallback';
import { AppPinLockScreen } from '@/components/app-pin/AppPinLockScreen';

export function AppPinLockGate({ children }: { children: React.ReactNode }) {
  const { ready, locked } = useAppPinLock();
  if (!ready) {
    return <RouteFallback />;
  }
  if (locked) {
    return <AppPinLockScreen />;
  }
  return <>{children}</>;
}
